import {ModuleComponent} from "../../js/module-component";

/**
 * Testimonios en caja verde (SEION).
 *  - Autoplay en bucle, flechas, indicadores clicables y pausa al hover.
 *
 * Trampas del handoff respetadas:
 *  1) El estado va por CLASES (.is-active) aplicadas a la vez a slide, foto e
 *     indicador → nunca se descuadran (el bug de los holes numéricos).
 *  2) El crossfade es solo opacity + pointer-events (nunca visibility).
 *  5) Las entradas son animación CSS; aquí solo se conmutan clases.
 *  La barra del indicador activo se reinicia relanzando la animación CSS,
 *  nunca se lleva en un "state" que re-renderice.
 */
export class ModAgentsSeven extends ModuleComponent{

    ready(){
        super.ready();
        this.el = this.$root.get(0);
        if(!this.el) return;

        this.slides = Array.from(this.el.querySelectorAll(".js-slide"));
        this.photos = Array.from(this.el.querySelectorAll(".js-photo"));
        this.dots   = Array.from(this.el.querySelectorAll(".js-dot"));
        if(this.slides.length === 0) return;

        this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        this.dwell = Math.max(2500, parseInt(this.el.dataset.dwell || "7000", 10) || 7000);
        this.active = 0;
        this.paused = false;

        // Flechas
        const prev = this.el.querySelector(".js-prev");
        const next = this.el.querySelector(".js-next");
        if(prev) prev.addEventListener("click", () => this.go(this.active - 1));
        if(next) next.addEventListener("click", () => this.go(this.active + 1));

        // Indicadores
        this.dots.forEach((dot) => {
            dot.addEventListener("click", () => this.go(Number(dot.dataset.index || 0)));
        });

        // Pausa al pasar el ratón
        this.root = this.el.querySelector(".js-root");
        if(this.root){
            this.onEnter = () => { clearTimeout(this.timer); this.paused = true; this.setBarState("paused"); };
            this.onLeave = () => { this.paused = false; this.setBarState("running"); this.schedule(); };
            this.root.addEventListener("pointerenter", this.onEnter);
            this.root.addEventListener("pointerleave", this.onLeave);
        }

        this.restartBar();
        this.schedule();
    }

    schedule(){
        if(this.reduceMotion || this.slides.length < 2) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.go(this.active + 1), this.dwell);
    }

    go(index){
        const total = this.slides.length;
        this.active = ((index % total) + total) % total;   // envuelve en ambos sentidos

        // Trampa 1: slide, foto e indicador se actualizan siempre juntos.
        this.slides.forEach((el, i) => {
            const on = i === this.active;
            el.classList.toggle("is-active", on);
            if(on){ el.removeAttribute("aria-hidden"); } else { el.setAttribute("aria-hidden","true"); }
        });
        this.photos.forEach((el, i) => el.classList.toggle("is-active", i === this.active));
        this.dots.forEach((el, i) => el.classList.toggle("is-active", i === this.active));

        this.restartBar();
        if(!this.paused) this.schedule();
    }

    // La barra se reinicia relanzando la animación CSS (no vive en el estado).
    restartBar(){
        this.dots.forEach((dot, i) => {
            const fill = dot.querySelector(".js-dot-fill");
            if(!fill) return;
            if(i === this.active && !this.reduceMotion){
                fill.style.animation = "none";
                void fill.offsetWidth;                    // fuerza reflow
                fill.style.animation = "a07Bar " + this.dwell + "ms linear forwards";
                fill.style.animationPlayState = this.paused ? "paused" : "running";
            }else{
                fill.style.animation = "none";
                fill.style.transform = "scaleX(0)";
            }
        });
    }

    setBarState(state){
        const fill = this.dots[this.active] && this.dots[this.active].querySelector(".js-dot-fill");
        if(fill) fill.style.animationPlayState = state;
    }

    destroy(){
        clearTimeout(this.timer);
        if(this.root && this.onEnter){
            this.root.removeEventListener("pointerenter", this.onEnter);
            this.root.removeEventListener("pointerleave", this.onLeave);
        }
        if(super.destroy) super.destroy();
    }
}
